<template>
	<div class="container" id="profile_section">
		<div v-if="user_level < 90">
			<h5 class="text-danger text-center mt-5">Access Denied!</h5>
		</div>

		<div v-else>
			<div class="row gold text-center">
				<div class="col-md-6 col-12">
					<h2>
						<i class="fas fa-users"></i> Business Teams (<small v-text="totalRows"></small>)
					</h2>
				</div>
				<div class="col-md-6 col-12">
					<button type="button" class="btn btn-sm btn-outline-secondary" @click="teamAdd">
						<i class="fas fa-user-plus"></i> Add New Team
					</button>
				</div>
			</div>

			<b-modal id="modal-team" :title="modal.title" ref="modal-team" no-close-on-backdrop>
				<b-form @submit="submitTeamForm($event)">
					<b-form-group>
						<small class="text-muted">Team Status</small>
						<b-form-select
							v-model="modal.team.status"
							:options="statuses"
							@change="validate(modal.team)"
						></b-form-select>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Team Name</small>
						<b-form-input
							v-model="modal.team.title"
							type="text"
							required
							placeholder="Enter team name"
							@change="validate(modal.team)"
						></b-form-input>
						<small class="text-danger" v-if="modal.team.title === ''"
							>Enter a team name</small
						>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">
							Select team leader/s<br />
							*
							<small class="text-danger"
								>Member account must have a Coach status or higher to be selectable...
							</small>
						</small>
						<v-select
							:options="team_leaders"
							:filterable="false"
							:multiple="true"
							@search="teamLeadersSearch"
							v-model="modal.team.team_leader_selected"
						>
							<template slot="no-options"> Search and select the team leader </template>

							<template slot="option" slot-scope="option">
								<div class="d-center">
									{{ option.label }}
								</div>
							</template>

							<template slot="selected-option" slot-scope="option">
								<div class="selected d-center">
									{{ option.label }}
								</div>
							</template>
						</v-select>

						<small class="text-danger" v-if="modal.team.team_leader_selected === null">
							Select team Leader/s
						</small>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Select team members</small>
						<v-select
							:options="team_members"
							:filterable="false"
							:multiple="true"
							@search="membersSearch"
							v-model="modal.team.team_members_selected"
						>
							<template slot="no-options"> Search and select the team leader </template>

							<template slot="option" slot-scope="option">
								<div class="d-center">
									{{ option.label }}
								</div>
							</template>

							<template slot="selected-option" slot-scope="option">
								<div class="selected d-center">
									{{ option.label }}
								</div>
							</template>
						</v-select>

						<small class="text-danger" v-if="modal.team.team_members_selected === null"
							>Select team members</small
						>
					</b-form-group>
				</b-form>

				<p><small class="text-danger" v-text="modal.errors.process"></small></p>

				<template #modal-footer="{ cancel }">
					<div class="w-100 row">
						<div class="col text-left">
							<b-button
								type="button"
								size="md"
								variant="success"
								:disabled="modal.submitDisabled"
								@click="submitTeamForm()"
								>Save
							</b-button>
						</div>
						<div class="col text-right">
							<b-button
								size="sm"
								@click="confirmBox()"
								name="delete"
								variant="outline-danger"
								>Delete
							</b-button>
							<b-button size="sm" variant="outline-secondary" @click="cancel('cancel')">
								cancel
							</b-button>
						</div>
					</div>
				</template>
			</b-modal>

			<div class="row" id="teams_wrap">
				<div class="col-md-6 my-1">
					<b-form-group class="mb-0">
						<b-input-group size="sm">
							<b-form-input
								id="filter-input"
								v-model="filter"
								type="search"
								placeholder="Search teams"
							></b-form-input>

							<b-input-group-append>
								<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</div>

				<div class="col-md-3 col-4 my-1">
					<b-form-group class="mb-0">
						<b-form-select
							id="per-page-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
						></b-form-select>
					</b-form-group>
				</div>

				<div class="col-md-3 col-8 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>

				<div class="col-12">
					<b-table
						bordered
						responsive
						:items="teams"
						:busy="isBusy"
						:fields="fields"
						:filter="filter"
						:filter-included-fields="filterOn"
						@filtered="onFiltered"
						:current-page="currentPage"
						:per-page="perPage"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						sort-icon-left
						class="small"
						show-empty
					>
						<template v-slot:table-busy>
							<div class="text-center my-2 p-2">
								<b-spinner class="align-middle"></b-spinner>
								<br />
								<strong>Loading...</strong>
							</div>
						</template>

						<template v-slot:cell(status)="data">
							<span v-text="arrayElmGet(statuses, data.item.status)"></span>
						</template>

						<template v-slot:cell(team_leader_selected)="data">
							<span
								v-for="val in data.item.team_leader_selected"
								v-text="val.label + ', '"
								:key="'M_' + val.id"
								class="mr-1"
							></span>
						</template>

						<template v-slot:cell(team_members_selected)="data">
							<span
								v-for="val in data.item.team_members_selected"
								v-text="val.label + ', '"
								:key="'M_' + val.id"
								class="mr-1"
							></span>
						</template>

						<template v-slot:cell(actions)="data">
							<b-dropdown
								size="sm"
								split
								split-variant="outline-primary"
								class="gold"
								:text="data.item.title"
								@click="dashboardView(data.item)"
							>
								<b-dropdown-item>
									<div>
										<a href="#" @click="dashboardView(data.item)"> View Team </a>
									</div>
								</b-dropdown-item>
								<b-dropdown-item>
									<div>
										<a href="#" @click="teamEdit($event, data.item)"> Edit </a>
									</div>
								</b-dropdown-item>
							</b-dropdown>
						</template>
					</b-table>
				</div>

				<div class="col-12 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
	name: 'BusinessOwners',
	components: {
		vSelect,
	},
	props: {},
	data() {
		return {
			modal: {
				title: '',
				submitDisabled: true,
				team: {},
				team_leader: '',
				errors: {
					process: '',
				},
			},
			modal_team_default: {
				id: 0,
				title: '',
				status: 1,
				team_leader_selected: null,
				team_members_selected: null,
			},

			statuses: [
				{ value: 0, text: 'Closed (deleted)' },
				{ value: 1, text: 'Active' },
				{ value: 2, text: 'Pending' },
			],

			errors: {},
			teams: null,
			team_leaders: [],
			team_members: [],
			//team_leader_selected: null,
			fields: [
				{ key: 'actions', sortable: false, label: 'Actions', class: '' },
				{ key: 'title', sortable: true, label: 'Team', class: '' },
				{ key: 'team_leader_selected', sortable: true, label: 'Team Coach', class: '' },
				{ key: 'team_members_selected', sortable: true, label: 'Members', class: '' },
				{ key: 'status', sortable: true, label: 'Status', class: '' },
				{ key: 'id', sortable: true, label: 'ID', class: '' },
			],
			isBusy: true,
			sortBy: 'user_score',
			sortDirection: 'desc',
			sortDesc: true,
			totalRows: 0,
			currentPage: 1,
			perPage: 50,
			pageOptions: [
				{ value: 50, text: 'Num to Show' },
				25,
				50,
				100,
				{ value: 500, text: 'All' },
			],
			filter: null,
			filterOn: [],
		};
	},
	methods: {
		arrayElmGet(obj, value) {
			const entries = Object.entries(obj);
			for (const v of entries) {
				if (parseInt(v[1].value) === parseInt(value)) {
					return v[1].text;
				}
			}
			return null;
		},
		confirmBox() {
			this.$bvModal
				.msgBoxConfirm('Are you sure you want to delete this team?')
				.then((value) => {
					if (value == true) {
						this.modal.team.status = 0;
						this.submitTeamForm();
					} else {
						this.$bvModal.hide('modal-team');
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		dashboardView(item) {
			this.$router.push('/teams/' + item.id);
		},
		membersSearch(search, loading) {
			if (search.length) {
				loading(true);
				this.membersGet(loading, search, this);
			}
		},
		membersGet(loading, search, vm) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('search_term', search);
			params.append('type', 'team_members');
			axios({
				url: _this.$store.state.api_url + 'teamMembersSearch',
				params: params,
			})
				.then(function (response) {
					console.log(vm.options); // = response.data.items;
					_this.team_members = Object.values(response.data.items);
					loading(false);
				})
				.catch(function () {
					console.log('Error: membersGet.');
				});
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		submitTeamForm(e) {
			let _this = this;
			if (e) {
				e.preventDefault();
			}

			this.validate(_this.modal.team);

			_this.modal.errors.process = 'Processing...';

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('status', _this.modal.team.status);
			params.append('title', _this.modal.team.title);
			params.append('id', _this.modal.team.id);

			if (_this.modal.team.team_leader_selected) {
				const team_leader = Object.values(_this.modal.team.team_leader_selected);
				for (const item of team_leader) {
					params.append('team_leader[]', item.id);
				}
			}

			if (_this.modal.team.team_members_selected) {
				const team_members = Object.values(_this.modal.team.team_members_selected);
				for (const item of team_members) {
					params.append('team_members[]', item.id);
				}
			}

			axios({
				url: _this.$store.state.api_url + 'teamAddEdit',
				params: params,
			})
				.then(function (response) {
					_this.modal.errors.profile = response.data.message;
					if (response.data.status == 1) {
						if (response.data.team !== null) {
							if (response.data.type == 'add') {
								_this.teams.unshift(response.data.team);
								_this.modal.team = _this.modal_team_default;
							} else {
								if (_this.modal.team.status === 0) {
									_this.teams = _this.teams.filter(
										(item) => item.id !== _this.modal.team.id
									);
								} else {
									_this.teams.find((obj) => {
										if (obj.team_leader_user_id === _this.modal.team.id) {
											obj = response.data.team;
										}
									});
								}
							}
						}

						_this.totalRows = _this.teams.length;

						_this.$bvModal.hide('modal-team');
					} else {
						_this.modal.errors.process = response.data.message;
					}
				})
				.catch(function () {});
		},
		teamAdd() {
			this.modal.team = {};
			if (!this.modal.team.title) {
				this.modal.title = 'Add Team';
				this.modal.team = this.modal_team_default;
				this.modal.errors.process = '';
			}
			this.$bvModal.show('modal-team');
			this.validate(this.modal.team);
		},
		teamEdit(e, team) {
			this.modal.title = 'Edit Team';
			this.modal.errors.process = '';
			this.modal.team = team;

			if (team.team_leader_selected) {
				this.modal.team.team_leader_selected = Object.values(team.team_leader_selected);
			}

			if (team.team_members_selected) {
				this.modal.team.team_members_selected = Object.values(team.team_members_selected);
			}

			this.$bvModal.show('modal-team');
			this.validate(this.modal.team);
		},
		teamsGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			axios({
				url: _this.$store.state.api_url + 'teamsGet',
				params: params,
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						_this.teams = Object.values(response.data.teams);
					} else {
						_this.teams = null;
					}
					_this.totalRows = _this.teams.length;
				})
				.catch(function () {
					console.log('Error: teamsGet.');
				});
		},
		teamLeadersGet(loading, search, vm) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('search_term', search);
			params.append('type', 'team_leaders');
			axios({
				url: _this.$store.state.api_url + 'teamMembersSearch',
				params: params,
			})
				.then(function (response) {
					console.log(vm.options); // = response.data.items;
					_this.team_leaders = Object.values(response.data.items);
					loading(false);
				})
				.catch(function () {
					console.log('Error: teamLeadersGet.');
				});
		},
		teamLeadersSearch(search, loading) {
			if (search.length) {
				loading(true);
				this.teamLeadersGet(loading, search, this);
			}
		},
		validate(team) {
			var valid = true;
			if (team.status === '' || team.status === 'null') {
				valid = false;
			}
			if (team.title === '') {
				valid = false;
			}

			if (valid == true) {
				this.modal.submitDisabled = false;
				return false;
			} else {
				this.modal.submitDisabled = true;
				return true;
			}
		},
	},
	computed: {
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
		active_profile() {
			return this.$store.getters.profileGet;
		},
		user_level() {
			return this.active_profile.level;
		},
	},
	created() {},
	mounted() {
		this.teamsGet();
	},
	watch: {},
};
</script>
